var map = {
	"./left_01.png": "ab91",
	"./left_02.png": "d00d",
	"./left_03.png": "8279",
	"./left_04.png": "86c0",
	"./left_05.png": "26ed",
	"./left_06.png": "f313",
	"./left_07.png": "729c",
	"./left_08.png": "f1b6",
	"./left_09.png": "b78e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1879";